import { Users, Sparkles, CalendarClock, CalendarCheck, Copy, ChevronRight } from "lucide-react";

function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("pt-PT", { day: "2-digit", month: "short", year: "numeric" });
}

const Card = ({ label, value, sub, icon: Icon, gold, testid, onClick, hint }) => {
  const clickable = typeof onClick === "function";
  const Comp = clickable ? "button" : "div";
  return (
    <Comp
      data-testid={testid}
      onClick={onClick}
      className={`text-left bg-[#18181b] border border-[#27272a] p-5 flex flex-col gap-3 transition-colors ${
        clickable
          ? "hover:border-[#c8aa6e] cursor-pointer focus:outline-none focus:border-[#c8aa6e] group"
          : "hover:border-[#3f3f46]"
      }`}
    >
      <div className="flex items-center justify-between">
        <span className="label-tiny">{label}</span>
        <Icon className="w-4 h-4 text-[#71717a]" strokeWidth={1.5} />
      </div>
      <div className={`font-head text-3xl font-light ${gold ? "text-[#c8aa6e]" : "text-[#fafafa]"}`}>
        {value}
      </div>
      {sub && <div className="text-xs text-[#71717a]">{sub}</div>}
      {clickable && hint && (
        <div className="text-[10px] text-[#71717a] group-hover:text-[#c8aa6e] flex items-center gap-1 mt-auto transition-colors">
          {hint} <ChevronRight className="w-3 h-3" />
        </div>
      )}
    </Comp>
  );
};

export default function KpiCards({ stats, onOpen = () => {} }) {
  if (!stats) return null;
  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
      <Card testid="kpi-total" label="Total de Perfis" value={stats.total} icon={Users} gold
        sub={`${stats.with_phone} com nº · ${stats.unique_people} pessoas únicas`}
        hint="Ver todos os perfis"
        onClick={() => onOpen({ view: "profiles" })} />
      <Card testid="kpi-new-today" label="Novos Hoje" value={stats.new_today} icon={Sparkles} gold
        hint="Ver novos de hoje"
        onClick={() => onOpen({ view: "profiles", onlyNew: true })} />
      <Card testid="kpi-new-week" label="Novos esta Semana" value={stats.new_week} icon={Sparkles}
        hint="Ver novos recentes"
        onClick={() => onOpen({ view: "profiles", onlyNew: true })} />
      <Card testid="kpi-multi" label="Nºs com vários anúncios" value={stats.multi_ad_people} icon={Copy}
        hint="Ver números duplicados"
        onClick={() => onOpen({ view: "duplicates" })} />
      <Card testid="kpi-first" label="Primeiro Registo" value={fmtDate(stats.first_date)} icon={CalendarClock} />
      <Card testid="kpi-last" label="Último Registo" value={fmtDate(stats.last_date)} icon={CalendarCheck} />
    </div>
  );
}
